export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = useUserStore()
  user.loading = true
})
